import React, { useEffect, useMemo, useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';


const initialValues = {
};

const validationSchema = Yup.object({
});

const Update = () => {

    const { id, nationalNo } = useParams()


    const { addData: updateDeliverAgent } = useEntityCrud('Business/updateDeliverAgent');
    const navigate = useNavigate();
    const { readData: searchDeliveries } = useEntityCrud('Business/getDeliverAgents');
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')

    const [rows, setRows] = useState([]);
    const [activeId, setActiveId] = useState(0);
    const [businessId, setBuisnessId] = useState(0);
    const [nationalCode, setNationalCode] = useState("");

    const [businessList, setBusinessList] = useState([]);
    const businessAll = useMemo(() => businessList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    useEffect(() => {
        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });
    }, [])

    const [groupList, setGroupList] = useState([]);
    const [deliveryType, setDeliveryType] = useState(0);
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: ""
    })

    useEffect(() => {
        debugger

        const businessIdDelivery = localStorage.getItem("businessIdDelivery")
        const postedData = {
            "businessId": businessIdDelivery,
            "person": {
                "nationalCode": nationalNo
            }
        }
        searchDeliveries(postedData).then((res) => {
            debugger
            if (res.data.status) {
                const data = res.data.result[0];
                setRows(res.data.result)
                formik.setValues({
                    delivervehicle1: data.vehicleNo.slice(0, 3),
                    delivervehicle2: data.vehicleNo.slice(3, 8),
                    businessId: { value: businessIdDelivery, label: localStorage.getItem("businessTitle") },
                    name: data.person.name,
                    lastName: data.person.lastName,
                    nationalCode: nationalNo,
                    phone: data.person.phone,
                    cellphone: data.person.cellphone,
                    description:data.description
                });
                setOrgAddress({ buisnessId: ({ value: businessIdDelivery, label: localStorage.getItem("businessTitle") }) })
                setActiveId(data.isActive)
            }
            else {
                toast.error(res.data.message)
                setRows([])
            }
        })
    }, []);


    let userDataBusinessId = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).businessId : {};


    const onSubmit = (values) => {
        debugger
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            id,
            "businessId": userDataBusinessId[0],
            "vehicleNo": values.delivervehicle1 + values.delivervehicle2,
            "description": values.description || "",
            "isActive": activeId,
            "person": {
                "offset": 0,
                "limit": 10,
                "name": values.name,
                "lastName": values.lastName,
                "nationalCode": values.nationalCode,
                "phone": values.phone,
                "cellphone": values.cellphone,
                "email": "",
                "isActive": true,
                "roleId": 0,
                "branchId": 0,
                "personTypeId": 0,
                "branchTitle": ""
            }
        };
        updateDeliverAgent(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('به روزرسانی پیک  با موفقیت انجام شد');
                return navigate('/Deliveries');
            } else
                toast.error(data.message)
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/Deliveries', { replace: true });
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش پیک</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik}
                    isEditMode={true}
                    deliveryType={deliveryType} setDeliveryType={setDeliveryType}
                    groupList={groupList} setGroupList={setGroupList}
                    businessList={businessList} setBusinessList={setBusinessList}
                    orgAddress={orgAddress} setOrgAddress={setOrgAddress}
                />
            </div>
        </div>
    );
}

export default Update;